import { commitPosterThemeSelection } from '@runtime/core/theme/commitPosterThemeSelection'
import {
  precacheThemeAssets,
  resolveTheme,
} from '@runtime/core/theme/posterThemes'
import { setPosterThemeAccessToken } from '@runtime/core/theme/posterAccess'

type ApplyPosterThemeSelectionArgs = {
  themeId: string
  accessToken?: string | null
  setThemeId: (themeId: string) => void
}

export async function applyPosterThemeSelection({
  themeId,
  accessToken,
  setThemeId,
}: ApplyPosterThemeSelectionArgs): Promise<void> {
  if (accessToken) setPosterThemeAccessToken(themeId, accessToken)
  const cfg = await resolveTheme(themeId)
  if (!cfg) throw new Error('poster_theme_unavailable')
  await precacheThemeAssets(themeId, cfg)
  commitPosterThemeSelection({ themeId, cfg, setThemeId })
}
